/**
 * @deprecated use ServerZoneType instead
 */
export enum ServerZone {
  US = 'US',
  EU = 'EU',
}

export type ServerZoneType = 'US' | 'EU';
